// Mount brand detection — returns brand metadata for a mount string.
// Used by ProductDetail to render the right camera-brand logo next to a mount.
const SIMPLE_ICON = (slug) => `https://cdn.simpleicons.org/${slug}/ffffff`;

const RULES = [
  { test: /sony/i, brand: "Sony", icon: SIMPLE_ICON("sony") },
  { test: /nikon/i, brand: "Nikon", icon: SIMPLE_ICON("nikon") },
  { test: /canon/i, brand: "Canon", icon: SIMPLE_ICON("canon") },
  { test: /(panasonic|lumix|l-mount|leica|sigma\s*l)/i, brand: "Panasonic", icon: SIMPLE_ICON("panasonic") },
  { test: /fuji/i, brand: "Fujifilm", icon: SIMPLE_ICON("fujifilm") },
  { test: /(m43|micro\s*four\s*thirds|olympus)/i, brand: "Olympus", icon: SIMPLE_ICON("olympus") },
];

export function getMountBrand(mount) {
  if (!mount) return null;
  for (const r of RULES) {
    if (r.test.test(mount)) return { brand: r.brand, icon: r.icon };
  }
  return null;
}
